import { render } from "./SvgRedTag.vue?vue&type=template&id=d5fc1808&ts=true"
import script from "./SvgRedTag.vue?vue&type=script&lang=ts"
export * from "./SvgRedTag.vue?vue&type=script&lang=ts"

import "./SvgRedTag.vue?vue&type=style&index=0&id=d5fc1808&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__